import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import config from 'utils/config';
import FormField from 'components/FormField';
import CheckboxOption from 'components/CheckboxOption';
import Stack from 'components/Stack';
import { MemberContributionsCheckbox } from './MemberContributionsFields';
var AdditionalOptionsField = function AdditionalOptionsField(_ref) {
  var _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
    isMemberContributionsEnabled = _ref.isMemberContributionsEnabled,
    isNumberingEnabled = _ref.isNumberingEnabled,
    onChangeMemberContributions = _ref.onChangeMemberContributions,
    onChangeNumbering = _ref.onChangeNumbering,
    isDistributed = _ref.isDistributed,
    isDeleted = _ref.isDeleted;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var memberContributionId = "member-contributions-".concat(uniqueId);
  var contentNumberingId = "content-numbering-".concat(uniqueId);
  var isDeletedOrDistributed = isDistributed || isDeleted;
  var hasMemberContributionsOption = config.memberContributions;
  return /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('panel_additional_options_title'),
    horizontal: horizontal,
    horizontalLabelOffset: 0
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(CheckboxOption, {
    label: t('actions_display_content_numbers'),
    checked: isNumberingEnabled,
    onChange: onChangeNumbering,
    id: contentNumberingId,
    disabled: isDeleted
  }), hasMemberContributionsOption && /*#__PURE__*/React.createElement(MemberContributionsCheckbox, {
    isDisabled: isDeletedOrDistributed,
    checked: isMemberContributionsEnabled,
    id: memberContributionId,
    onChange: onChangeMemberContributions
  })));
};
export default AdditionalOptionsField;